<div class="loader">
    <div class="loader__title">Ex Astris</div>
    {{!-- <div class="loader__subtitle">Ad Infinitum</div> --}}
    <div class="loader__status">
        <div class="loader__message"></div>
        <div class="loader__progress-bar">
            <div class="loader__progress-fill"></div>
        </div>
    </div>
</div>